module.exports = __webpack_public_path__ + "assets/img/Sonance_004.0effdb69.jpg";